import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ResGetCaseAlertListQuery } from './types'

export const getCaseAlertListQueryKey = (caseId?: number) => [API_ENDPOINTS.business.v1.alert.index, { caseId }]
export const getCaseAlertListQuery = (caseId?: number) =>
  queryOptions({
    queryKey: getCaseAlertListQueryKey(caseId),
    queryFn: (): Promise<ResGetCaseAlertListQuery> =>
      w.query({ caseId }).get(`${API_ENDPOINTS.business.v1.alert.index}/${caseId}`).json(),
    enabled: !!caseId,
  })
